import { FC, useEffect, useState } from 'react';
import { FavoriteProductListComponent } from '../../components/Favorites/favorite-product-list/ProductListComponent';
import { useSelector } from 'react-redux';
import { ErrorState, FavoriteAddDate, RootState } from './../../redux/AppReducer';
import { GET_PRODUCTS } from '../../graphql/queries/products';
import { AppActions } from '../../redux/AppActions';
import { FavoriteHeaderComponent } from '../../components/Favorites/FavoriteHeader/FavoriteHeaderComponent';
import { UserType, Product } from '../../common/model';
import { useQuery } from '@apollo/client';
import { findUserAccessType } from '../../helpers/findUserAccessType';
import { GENERAL_ERRORS, serverError } from '../../common/constants';
import { useAppDispatch } from '../../redux/store';
import { AuthActions } from '../../redux/AuthActions';

const FavoritesPage: FC<{ isProfilePage: boolean }> = ({ isProfilePage }) => {
	const dispatch = useAppDispatch();
	const currentEvent = useSelector(
		(state: RootState) => state.appState?.storeState?.getCurrentEvent
	);
	const [viewMode] = useState('grid');
	const [userType, setUserType] = useState<UserType | undefined>();
	const [favoriteProducts, setFavoriteProducts] = useState<Array<FavoriteAddDate> | undefined>();
	const [user, setUser] = useState<any>();
	const [ingredientsTemplateId, setIngredientsTemplateId] = useState<number | undefined>();
	const userState = useSelector((state: RootState) => state.appState?.userState!);
	const { favoriteSortBySelected } = useSelector(
		(state: RootState) => state.appState?.filterState!
	);
	const tokenHasError = useSelector(
		({ appState: state }: RootState) => state.authState?.tokenHasError
	);
	const [products, setProducts] = useState<Product[]>([]);
	const setStandAloneLayout = (standAloneLayout: boolean) =>
		dispatch(AppActions.setStandAloneLayout(standAloneLayout));
	const handleUnauthorized = () => dispatch(AppActions.unauthorizedError());
	const handleError = (error: ErrorState) => dispatch(AppActions.setGeneralError(error));
	useEffect(() => {
		setFavoriteProducts(userState.favoriteProducts);
		setIngredientsTemplateId(userState.ingredientsTemplateId);
		setUser(userState.user);
		setUserType(userState.user?.user_type);
	}, [userState]);

	useEffect(() => {
		setStandAloneLayout(false);
	}, []);
	const { loading, data, error, refetch } = useQuery(GET_PRODUCTS, {
		variables: {
			genericFilters: [],
			sortAttribute: favoriteSortBySelected?.productSort.attribute,
			sortDirection: favoriteSortBySelected?.productSort.order,
			templateId: String(ingredientsTemplateId || '1'),
			favoriteProducts: true,
			expoEventId: currentEvent?.id || null
		},
		fetchPolicy: 'no-cache'
	});
	useEffect(() => {
		if (!error && !loading && data?.products?.products) {
			setProducts(data?.products?.products);
		}
		if (error?.message === 'Unauthorized') {
			if (tokenHasError === 0) {
				dispatch(AuthActions.setTokenError(1));
			}
			return;
		}
		if (error?.message === GENERAL_ERRORS.USER_TOKEN_EXPIRED) {
			handleUnauthorized();
		}
		if (error) {
			handleError(serverError);
		}
	}, [data, error, loading]);
	useEffect(() => {
		if (
			!userType ||
			(findUserAccessType(userType) === UserType.Retailer && !ingredientsTemplateId) ||
			!user ||
			!favoriteProducts
		) {
			return;
		}
		refetch();
	}, [refetch, ingredientsTemplateId, user, favoriteProducts, favoriteSortBySelected, userType]);
	return (
		<>
			<FavoriteHeaderComponent products={products} isLoading={!!(loading && currentEvent?.id)} />
			<FavoriteProductListComponent
				products={products}
				viewMode={viewMode}
				isProfilePage={isProfilePage}
				isLoading={loading}
			/>
		</>
	);
};

export default FavoritesPage;
